<template>
  <footer
    class="flex justify-between w-full content-end flex-nowrap md:flex-wrap"
  >
    <p class="sm:text-small">{{ $t('login.footer_copyright', { year: new Date().getFullYear() }) }}</p>
    <a
      href="https://intercom.help/meridia/en/"
      target="_blank"
      class="link"
      rel="noopener noreferrer"
    >
      {{ $t('login.meridia_help_center') }}
    </a>
  </footer>
</template>
<script setup lang="ts"></script>
